import React, { useEffect, useRef } from 'react'
import styles from "./aboutusSec.module.css";
import { officeImg1, officeImg2, officeImg3, officeImg4, officeImgHover1, officeImgHover2, officeImgHover3, officeImgHover4 } from '../../../assets';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import useTextAnimation from '../../hooks/useTextAnimation';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useDispatch, useSelector } from 'react-redux';
import { fetchOfficesData } from '../../slice/officeSlice';
import { IMAGE_URL } from '../../helpers/api_helper';
import { useTranslation } from 'react-i18next';
import { LANG_AR, LANG_EN } from '../../helpers/constant';

gsap.registerPlugin(ScrollTrigger);

const AboutOffice = ({officeData}) => {
    const { ref: ofcTRef, inView: ofcTInView, textAnimation } = useTextAnimation();

    /*  const dispatch = useDispatch();
     const {data: officeData, loading, error} = useSelector((state) => state.office);

     useEffect(() => {
            dispatch(fetchOfficesData());
     },[dispatch]);

     useEffect(() => {
            console.log('Office Data : ', officeData);
     },[officeData]);    */

     const {t, i18n}= useTranslation()

    return (
        <>
            <div className={styles._office} >
                <div className={styles._officeTitle} >
                    <motion.h3 ref={ofcTRef}
                        initial="hidden"
                        animate={ofcTInView ? "visible" : "hidden"}
                        custom={0}
                        variants={textAnimation}>{t('contactOffice')}</motion.h3>
                </div>
                <ul className={`${styles._officeImgs} ${i18n.language=== LANG_AR? 'arab':''}`} >
                    {officeData.length > 0 && officeData.map((office, index) => (
                             <li key={index}>
                             <div className={styles._officeImgP}>
                                 <div className={styles._officeImg}>
                                    {/*  <img className={styles._officeImgDef} src={officeImgHover1} alt="" />
                                     <img className={styles._officeImgHover} src={officeImg1} alt="" /> */}

                                     <img className={styles._officeImgDef} src={`${IMAGE_URL}/office/${office.image}`} alt="" loading='lazy' />
                                     <img className={styles._officeImgHover} src={`${IMAGE_URL}/office/${office.blurImage}`} alt="" loading='lazy' />
                                 </div>
                                 <div className={`${styles._officeImgDsc} ${i18n.language===LANG_AR? 'arabT':''} `}>
                                     {/* <h3>{office.city}</h3>
                                     <p>{office.officeName}</p> */}
                                     <h3>{i18n.language===LANG_EN ? office.city : office.cityAr}</h3>
                                     <p>{i18n.language=== LANG_EN ? office.officeName :office.officeNameAr}</p>
                                 </div>
                             </div>
                         </li>
                    ))}
                    {/* <li>
                        <div className={styles._officeImgP}>
                            <div className={styles._officeImg}>
                                <img className={styles._officeImgDef} src={officeImgHover1} alt="" />
                                <img className={styles._officeImgHover} src={officeImg1} alt="" />
                            </div>
                            <div className={styles._officeImgDsc}>
                                <h3>Abu Dhabi</h3>
                                <p>Yas Creative Hub </p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className={styles._officeImgP}>
                            <div className={styles._officeImg}>
                                <img className={styles._officeImgDef} src={officeImgHover2} alt="" />
                                <img className={styles._officeImgHover} src={officeImg2} alt="" />
                            </div>
                            <div className={styles._officeImgDsc}>
                                <h3>Dubai</h3>
                                <p>Media City</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className={styles._officeImgP}>
                            <div className={styles._officeImg}>
                                <img className={styles._officeImgDef} src={officeImgHover3} alt="" />
                                <img className={styles._officeImgHover} src={officeImg3} alt="" />
                            </div>
                            <div className={styles._officeImgDsc}>
                                <h3>Cairo</h3>
                                <p>WaterWay Mall</p>
                            </div>
                        </div>
                    </li>
                    <li>
                        <div className={styles._officeImgP}>
                            <div className={styles._officeImg}>
                                <img className={styles._officeImgDef} src={officeImgHover4} alt="" />
                                <img className={styles._officeImgHover} src={officeImg4} alt="" />
                            </div>
                            <div className={styles._officeImgDsc}>
                                <h3>Riyadh</h3>
                                <p>Coming Soon</p>
                            </div>
                        </div>
                    </li> */}
                </ul>
            </div>
        </>
    )
}

export default AboutOffice
